import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Button, Drawer, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EventCard from '@ui/pages/Events/EventsHomePage/components/EventCard';
import FileUploaderForm from '../Forms/FileUploaderForm';
import { useStyledFileUploaderStyles } from './useStyledFileUploaderStyles';
const StyledFileUploader = ({ onChange, onFilesSubmitted, onValidationError, allowedFileTypes, allowedFileTypesText, allowedFileSize, error, infoText, disabled, isFamilyFest }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const styles = useStyledFileUploaderStyles(theme);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [errorText, setErrorText] = useState('');
    const [drawerOpen, setDrawerOpen] = useState(false);
    useEffect(() => {
        if (error)
            setErrorText(error);
    }, [error]);
    const renderForm = (_jsx(FileUploaderForm, { allowedFileTypes: allowedFileTypes, allowedFileTypesText: allowedFileTypesText, allowedFileSize: allowedFileSize, infoText: infoText, disabled: disabled, isFamilyFest: isFamilyFest, onFilesSubmitted: (files, title, type) => {
            onFilesSubmitted?.(files, title, type);
            if (isSmallScreen)
                setDrawerOpen(false);
        } }));
    if (isSmallScreen) {
        return (_jsxs(_Fragment, { children: [_jsx(Box, { py: 1, display: 'flex', justifyContent: 'flex-end', children: _jsx(Button, { variant: 'contained', onClick: () => setDrawerOpen(true), disabled: disabled, children: t('fileUpload.addAttachments') }) }), _jsx(Drawer, { anchor: 'bottom', PaperProps: {
                        sx: { ...styles.bottomAttachmentDrawer, backgroundColor: 'white !important' }
                    }, open: drawerOpen, onClose: () => setDrawerOpen(false), children: _jsx(Box, { children: renderForm }) })] }));
    }
    return (_jsx(EventCard, { variant: 'light', haveHeader: false, disableBackground: true, disableShadow: true, sx: { height: 'auto' }, children: renderForm }));
};
export default StyledFileUploader;
